export const PNR_INPUT_LIMIT = 10;
export const PNR_INPUT_LIMIT_ERROR = "PNR is needed to deliver to your seat";

export const IRCTC_NON_PNR_HALF_CARD_TEST_ID = "irctc-non-pnr-halfcard";

export const IRCTC_NON_PNR_HALF_CARD_DEFAULT_TEXT = {
    title: "Enter PNR",
    subtitle: "Enter your PNR to deliver to your seat",
    inputPlaceholder: "Type 10 digit PNR from ticket",
    cta: "Enter PNR",
};
